import { cn } from "@/lib/utils";

export interface QuickView {
  key: string;
  label: string;
  count: number;
  accent?: "destructive" | "warning" | "success" | "info" | "default";
}

interface Props {
  views: QuickView[];
  active: string;
  onChange: (key: string) => void;
}

const accentClasses: Record<string, string> = {
  destructive: "text-destructive",
  warning: "text-warning",
  success: "text-success",
  info: "text-info",
  default: "text-foreground",
};

export function QuickViews({ views, active, onChange }: Props) {
  return (
    <div className="flex gap-1 flex-wrap">
      {views.map((v) => {
        const isActive = active === v.key;
        return (
          <button
            key={v.key}
            onClick={() => onChange(v.key)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-[11px] font-medium transition-all",
              isActive
                ? "bg-primary text-primary-foreground border-primary shadow-sm"
                : "bg-background text-muted-foreground border-border hover:bg-muted hover:text-foreground"
            )}
          >
            {v.label}
            <span className={cn(
              "tabular-nums font-bold",
              isActive ? "text-primary-foreground/80" :
              v.count > 0 && v.accent ? accentClasses[v.accent] : "text-muted-foreground"
            )}>
              {v.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
